// DS: MO2.2
import React from 'react';
import c from 'classnames';
import CloseIconBold from '../Icons/CloseBold';
import { IconSize } from '../Icons/IconWrap';
import PlainButtonOrLink from '../Buttons/PlainButtonOrLink';
import s from './PreviewModeBar.scss';
const PreviewModeBar = ({ className, onClose, messageBeforeIcon, icon, ctaLabel, ctaHref, ctaOnClick, ctaBiData })=>{
    const renderCtaButton = ()=>{
        if (!ctaLabel) {
            return;
        }
        return /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
            className: s['cta-button'],
            href: ctaHref,
            onClick: ctaOnClick,
            biData: ctaBiData
        }, ctaLabel);
    };
    const renderCloseButton = ()=>{
        if (!onClose) {
            return;
        }
        return /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
            className: s['close-button'],
            onClick: onClose
        }, /*#__PURE__*/ React.createElement(CloseIconBold, {
            size: IconSize.SMALL,
            disableDefaultColors: true
        }));
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['snackbar']
    }, messageBeforeIcon && /*#__PURE__*/ React.createElement("div", {
        className: s['message-before-icon']
    }, messageBeforeIcon), icon, /*#__PURE__*/ React.createElement("div", {
        className: s['cta-button']
    }, renderCtaButton())), renderCloseButton());
};
export default PreviewModeBar;

//# sourceMappingURL=PreviewModeBar.js.map